import {
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild
} from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { AutofillDropdownService } from '../../services/autofill-dropdown.service';

@Component({
  selector: 'drp-autofill-dropdown',
  templateUrl: './autofill-dropdown.component.html',
  styleUrls: ['./autofill-dropdown.component.scss'],
  standalone: false
})
export class AutofillDropdownComponent implements OnInit, OnChanges {
  /**
   * List of full address predictions from Geo API based on what the user is typing
   */
  @Input() addressGuesses: any;

  /**
   * Optionally override the suggestions class
   */
  @Input() suggestionsClass = 'autocomplete-suggestions show-suggestions absolute';

  /**
   * Address the user selects
   */
  @Output() userSelectedAddress = new EventEmitter<any>();

  /**
   * get reference to dropdown menu element to handle keystroke events
   */
  @ViewChild('dropdownMenu', { static: true }) dropdownMenuElement: ElementRef<any>;

  activeChoice: any;
  dropdownShown: boolean;
  private dropdownStatus$ = new Subject<void>();

  constructor(private dropdown: AutofillDropdownService) {}

  ngOnInit() {
    this.dropdown.dropdownStatus
      .pipe(takeUntil(this.dropdownStatus$))
      .subscribe((status: boolean) => {
        this.dropdownShown = status;
      });
  }

  ngOnChanges(changes: SimpleChanges) {
    // eslint-disable-next-line guard-for-in
    for (const propName in changes) {
      const change = changes[propName];
      if (!change.isFirstChange()) {
        if (propName === 'addressGuesses') {
          this.dropdown.show();
        }
      }
    }
  }
  set addressChoices(choices: any[]) {
    if (choices.indexOf(this.activeChoice) === -1 && choices.length > 0) {
      this.activeChoice = this.addressGuesses[0];
    }
  }

  get addressChoices() {
    return this.addressGuesses;
  }

  /** Handle Keystoke events */
  @HostListener('document:keydown.ArrowDown', ['$event'])
  onArrowDown(event: KeyboardEvent) {
    event.preventDefault();
    const index = this.addressChoices.indexOf(this.activeChoice);
    if (this.addressChoices[index + 1]) {
      this.scrollToChoice(index + 1);
    }
  }

  @HostListener('document:keydown.ArrowUp', ['$event'])
  onArrowUp(event: KeyboardEvent) {
    event.preventDefault();
    const index = this.addressChoices.indexOf(this.activeChoice);
    if (this.addressChoices[index - 1]) {
      this.scrollToChoice(index - 1);
    }
  }

  @HostListener('document:keydown.Enter', ['$event'])
  onEnter(event: KeyboardEvent) {
    if (this.addressChoices.indexOf(this.activeChoice) > -1) {
      event.preventDefault();
      this.emitSelectedAddress(this.activeChoice);
      this.dropdown.hide();
    }
  }

  emitSelectedAddress(address) {
    this.userSelectedAddress.emit(address);
    this.dropdown.hide();
  }

  hideDropdownOnClick() {
    this.dropdown.hide();
  }

  private scrollToChoice(index: number) {
    this.activeChoice = this.addressGuesses[index];
    if (this.dropdownMenuElement) {
      const parentPosition = this.dropdownMenuElement.nativeElement.getBoundingClientRect();
      const child = this.dropdownMenuElement.nativeElement.children[index];
      const liPosition = child.getBoundingClientRect();
      if (liPosition.top < parentPosition.top) {
        child.scrollIntoView();
      } else if (liPosition.bottom > parentPosition.bottom) {
        child.scrollIntoView(false);
      }
    }
  }
}
